import { TW_POST_TYPES } from '@/lib/posts/postTypes';

import { QuoteBadge } from '@/components/composite/Post/Twitter/QuoteBadge';
import { ReplyBadge } from '@/components/composite/Post/Twitter/ReplyBadge';
import { RetweetBadge } from '@/components/composite/Post/Twitter/RetweetBadge';

type PostTypeBadgeProps = {
    type: string | null;
    isExport: boolean;
};

export const PostTypeBadge = ({ type, isExport }: PostTypeBadgeProps) => {
    if (type === TW_POST_TYPES.TYPE_RETWEET) {
        return <RetweetBadge isExport={isExport} />;
    }
    if (type === TW_POST_TYPES.TYPE_QUOTE) {
        return <QuoteBadge isExport={isExport} />;
    }
    if (type === TW_POST_TYPES.TYPE_REPLY) {
        return <ReplyBadge isExport={isExport} />;
    }
    return null;
};
